$(function(){
  
  var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}
  
  $('.homepage-slideshow-carousel').slick({
    autoplay: true,
    arrows: false,
    dots: false,
    infinite: true,
  });
  
  $('.leadership-carousel').slick({
    arrows: true,
    slidesToShow: 4,
    autoplay: true,
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  $('.testimonials-carousel').slick({
    arrows: true,
    slidesToShow: 1,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
  
  $('.get-started-carousel, .our-schools-carousel, .tai-chi-carousel, .self-defense-seminars-carousel, .bday-parties-carousel').slick({
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    slideToShow: 1,
    autoplaySpeed: 5000,
    adaptiveHeight: true
  });
  
 // lightbox.option({
   // 'resizeDuration': 200,
   // 'wrapAround': true
 // })
  
  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
      $(this).find('span').html('-');
      $(this).parent().next().slideDown();
    } else if($(this).parent().next().is(":visible")){
      $(this).parent().next().slideUp();
      $(this).parent().next('.accordion span').html('+');
      $(this).next('span').html('+');
      if($(this).find('span').html('+')) {
        $(this).find('span').html('+');
      } else if($(this).find('span').html('+')) {
        $(this).find('span').html('+');
      }
    }
    return false;
  });
  
  // ajax Forms
  $('form.try-a-class-form').on('submit', function(e){
    e.preventDefault();

    var form_name = $('form.try-a-class-form input[name=name]').val(),
        form_email = $('form.try-a-class-form input[name=email]').val(),
        form_phone = $('form.try-a-class-form input[name=phone]').val(),
        form_age = $('form.try-a-class-form input[name=age]').val(),
        form_program = $('form.try-a-class-form select[name=program]').val(),
        form_location = $('form.try-a-class-form select[name=location]').val(),
        form_experience = $('form.try-a-class-form select[name=experience]').val();

    var action  = '/contact?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[form_name]') +'='+ encodeURIComponent(form_name);
    action += '&'+ encodeURIComponent('contact[form_email]') +'='+ encodeURIComponent(form_email);
    action += '&'+ encodeURIComponent('contact[form_phone]') +'='+ encodeURIComponent(form_phone);
    action += '&'+ encodeURIComponent('contact[form_age]') +'='+ encodeURIComponent(form_age);
    action += '&'+ encodeURIComponent('contact[form_program]') +'='+ encodeURIComponent(form_program);
    action += '&'+ encodeURIComponent('contact[form_location]') +'='+ encodeURIComponent(form_location);
    action += '&'+ encodeURIComponent('contact[form_experience]') +'='+ encodeURIComponent(form_experience);

    submitAjaxForm( action, 'form.try-a-class-form', '<p class="fc-white center">Your message was sent successfully. Thanks.</p>');
  })
  
  $('form#contact_formx').on('submit', function(e){
    e.preventDefault();

    var form_name = $('form#contact_form input[name=name]').val(),
        form_email = $('form#contact_form input[name=email]').val(),
        form_body = $('form#contact_form textarea[name=message]').val();

    var action  = '/contact?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[form_name]') +'='+ encodeURIComponent(form_name);
    action += '&'+ encodeURIComponent('contact[form_email]') +'='+ encodeURIComponent(form_email);
    action += '&'+ encodeURIComponent('contact[form_body]') +'='+ encodeURIComponent(form_body);

    submitAjaxForm( action, 'form#contact_form', '<p class="fc-initial center">Your message was sent successfully.</p>');
  })
  
  $('form#judge_registration').on('submit', function(e){
    e.preventDefault();
    
    var form_lname 				= $('form#judge_registration input[name=lname]').val(),
        form_fname 				= $('form#judge_registration input[name=fname]').val(),
        form_belt_rank 			= $('form#judge_registration select[name=belt_rank]').val(),
        form_usksf 				= $('form#judge_registration select[name=usksf]').val(),
        form_t_shirt 			= $('form#judge_registration select[name=t_shirt]').val(),
        form_lunch 				= $('form#judge_registration select[name=lunch]').val(),
        form_time_restrictions 	= $('form#judge_registration textarea[name=time_restrictions]').val();

    var action  = '/contact?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[form_lname]') +'='+ encodeURIComponent(form_lname);
    action += '&'+ encodeURIComponent('contact[form_fname]') +'='+ encodeURIComponent(form_fname);
    action += '&'+ encodeURIComponent('contact[form_belt_rank]') +'='+ encodeURIComponent(form_belt_rank);
    action += '&'+ encodeURIComponent('contact[form_usksf]') +'='+ encodeURIComponent(form_usksf);
    action += '&'+ encodeURIComponent('contact[form_t_shirt]') +'='+ encodeURIComponent(form_t_shirt);
    action += '&'+ encodeURIComponent('contact[form_time_restrictions]') +'='+ encodeURIComponent(form_time_restrictions);

    submitAjaxForm( action, 'form#judge_registration', '<p>Thank you for your registration.</p>');
  });
  
  $('form#contact-bottom').on('submit', function(e){
    e.preventDefault();
    
    var form_name 				= $('form#contact-bottom input[name=name]').val(),
        form_email 				= $('form#contact-bottom input[name=email]').val(),
        form_message 			= $('form#contact-bottom textarea[name=message]').val();

    var action  = '/contact?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[form_name]') +'='+ encodeURIComponent(form_name);
    action += '&'+ encodeURIComponent('contact[form_phone]') +'='+ encodeURIComponent(form_email);
    action += '&'+ encodeURIComponent('contact[form_email]') +'='+ encodeURIComponent(form_message);

    submitAjaxForm( action, 'form#contact-bottom', '<p class="center">Your message was sent successfully.</p>');
  });
  
  
  
  // end ajax Forms
  
  // map  
  $(".lg-hotspot-label").show("fast");
  $(".lg-hotspot-label").hide();

  $(".lg-hotspot-button").click(function(){
    var thisLabel = $(this).siblings(".lg-hotspot-label");
    var thisLabelState = thisLabel.css("display");
    $(".lg-hotspot-label").fadeOut(0).parent().css("z-index", "0");
    if(thisLabelState=="none") {
      thisLabel.fadeIn(0);
      $(this).parent().css("z-index", "999");
    }
  });
  
  $('.lg-hotspot-label span.right').click(function(){
    $(".lg-hotspot-label").hide();
  });
  
  // scroll to top after add to cart
  $('form.custom input[type=submit]').click(function(e){
    e.preventDefault();
    
    $('.cart_container').show();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    $('form.custom').trigger('submit');
    
  });
  
  function submitAjaxForm(action, form, successText) {
    $.ajax({
      type: "POST",
      async: true,
      url: action,
      complete: function(response) {
        $(form).empty().append('<p class="text-center">'+successText+'</p>');
      }
    });
  }
  getCart();
  
 /*
  if( template == 'cart' ) {*/
  
    $('select#school').on('change', function(e) {
      let school 	= $(this).val(),
          other		= $('p#school-other');
      
      if ( school == 'Other' )
        other.removeClass('hidden');
      else
        other.addClass('hidden');
      
    });
 /* }*/
   
  
  var reg = false;
    
  if ( $('form.registration').length ) reg = true;
  
  // Custom Form
  if ( $('form.custom').length ) {
    
    $('form.custom input.product-qty').on('blur', function(e){
      
      e.preventDefault();
      
      var id = $(this).data('id');
      
      if ( $(this).val() > 0 ) updateCart( id, $(this).val() );
      else if ( $(this).val() == "" || $(this).val() == 0 ) updateCart( id, 0 );
      else return;
      
    });
    
    // product input check box
    $("form.custom input.product-checkbox").on('click', function() {
      var id 		= $(this).data('id'),
          target	= $(this).attr('id');
      
      if ( $(this).is(":checked") ) updateCart( id, 1 );
      else updateCart( id, 0 );
      
    });
    
    // variant input check box
    $("form.custom input.variant-checkbox").on('click', function(){
      
      if ( $(this).is(':checked') )
        addVariantWithPropertyToCart( $(this).attr('data-id'), 1, "Weapon", $(this).val() );
      else
        updateCart( $(this).attr('data-id'), 0 );
      
    });
    
    // variant select
    $("form.custom select.variant-select").on('change', function(){
      
      var target 		= $(this).data('target'),
          value 		= $(this).val(),
          input_target 	= $('input#'+target),
          id 			= input_target.attr('data-id'),
          old_value		= input_target.val();
      
      input_target.val( value );
      
      if( input_target.is(':checked') ) {
        
        $.ajax({
          url: '/cart.js',
          type: 'get',
          dataType: 'json',
          asyc: false,
          success: function(cart) {
            
            var line = 1;
            
            for( item in cart.items ) {
              
              let prop = cart.items[item].properties;
              
              if( prop && prop.Weapon ) {
                
                changeCartItemPropertyByLine( line, value );
                
                break;
              }
              
              line++;
            }
          }
        })
        
      }
      
    });
    
    // variant partner input
    $("form.custom input.partner-input").on('blur', function() {
      
      var target 		= $(this).data('target'),
          value 		= $(this).val(),
          input_target 	= $('input#'+target),
          id			= input_target.attr('data-id');
      
      input_target.val( value );
      
      if( input_target.is(':checked') ) {
        
        $.ajax({
          url: '/cart.js',
          type: 'get',
          dataType: 'json',
          asyc: false,
          success: function(cart) {
            
            var line	= 1,
                found 	= false;
            
            for( item in cart.items ) {
              
              let item_id = cart.items[item].id;
              
              console.log( item_id );
              
              if( item_id == id ) {
                
                found = true;
                
                $.ajax({
                  type: 'post',
                  dataType: 'json',
                  asyc: false,
                  url: '/cart/change.js',
                  data: {
                    line: line,
                    properties: {
                      'Partner': value
                    }
                  },
                  success: function( cart ) {

                    var total = cart.total_price / 100;

                    $('form.custom span#total').text( '$' + total.toFixed(2) );
                  }
                });
                
                break;
              }
            }
            
            if( !found ) {
              
              $.ajax({
                url: '/cart/add.js',
                asyc: false,
                dataType: 'json',
                type: 'post',
                data: {
                  id: id,
                  quantity: 1,
                  properties: { 'Partner': value }
                },
                success: function(resopnse) {
                  getCart();
                }

              });
            }
              
          }
        })
      }
    });
    
    // variant partner checkbox
    $("form.custom input.partner-checkbox").on('click', function() {
      
      $(this).parent('p').parent('.columns').siblings('.columns').find('input').attr('required', 'required');
      
    });
    
    
    $('form.custom input[type=radio]').on('change', function() {
      
      var id = $(this).val();
      
      if ( !$('form#taiChi').length ) updateCart( id, 1 );
      else {
      	
        if ( $(this).data('val') == "free" )
          $('form#taiChi span#total').text( '$0.00' );
        else
          $('form#taiChi span#total').text( '$300.00' );
        
        $('form#taiChi input[name="id"]').val( id );
      }
      
    });    
    
    $('.product-select').on('change', function(){
    
      var target 		= $(this).data('target'),
          value 		= $(this).val(),
          input_target 	= $('input#'+target),
          old_value		= input_target.attr('data-id');
      
      input_target.attr('data-id', value);
      
      if( input_target.is(':checked') ) {
        
        var data = "updates[19508985167958]=1&updates["+old_value+"]=0&updates["+value+"]=1";
      
        $.ajax({
          type: 'post',
          dataType: 'json',
          asyc: false,
          url: '/cart/update.js',
          data: data,
          success: function( cart ) {

            var total = cart.total_price / 100;

            $('form.custom span#total').text( '$' + total.toFixed(2) );
          }
        });
      }
      
    });

  }
  
  function emptyCart() {
    $.ajax({
      type: "POST",
      asyc: false,
      global: false,
      url: '/cart/clear.js',
      dataType: 'json'
    });
  }
  
  function getCart() {
    $.ajax({
      url: '/cart.js',
      type: 'get',
      dataType: 'json',
      asyc: false,
      success: function(cart) {
        
        if ( cart.items.length > 0 ) $('.top_bar .cart_container').show();
        
        var total = cart.total_price / 100;
        
        $('form.custom span#total').text( '$' + total.toFixed(2) );
        
        var template="";
        
        if ( template == 'cart' ) {
        
          if ( cart.attributes['First Name'] && cart.attributes['School'] ) {
            
            let name = cart.attributes['First Name']+' '+cart.attributes['Last Name'];

            $('input#name').val(name);
            
            let school = cart.attributes['School'];
            
            $("select#school option[value='"+school+"']").attr("selected","selected");

            if ( school == 'Other' ) $('p#school-other').removeClass('hidden');
          }
          else {
          
            for( item in cart.items ) {

              let prop = cart.items[item].properties;

              if( prop && prop['First Name'] ) {

                let name = prop['First Name']+' '+prop['Last Name'];

                $('input#name').val(name);
              }

              if( prop && prop['School'] ) {

                let school = prop['School'];

                $("select#school option[value='"+school+"']").attr("selected","selected");

                if ( school == 'Other' ) $('p#school-other').removeClass('hidden');
              }

            }
          }
          
        }
      }
    })
  }
  
  function addCart(id, qty) {
  
    $.ajax({
      type: 'post',
      dataType: 'json',
      asyc: false,
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id
      }
    });
    
  }
  
  function addVariantWithPropertyToCart( id, qty, property_name, property_value) {
    
    $.ajax({
      url: '/cart/add.js',
      asyc: false,
      dataType: 'json',
      type: 'post',
      data: {
        id: id,
        quantity: qty,
        properties: { 'Weapon': property_value }
      },
      success: function(resopnse) {
        getCart();
      }
      
    });
  }
  
  function updateCart( pId, qty ) {
    
    var data = "updates["+pId+"]="+qty;
    
//     if ( reg ) {
//       data = "updates[19508985167958]=1&updates["+pId+"]="+qty;
//     }
    
    $.ajax({
      type: 'post',
      dataType: 'json',
      asyc: false,
      url: '/cart/update.js',
      data: data,
      success: function( cart ) {
        
        var total = cart.total_price / 100;
        
        $('form.custom span#total').text( '$' + total.toFixed(2) );
      }
    });
  }
  
  function changeCartItemPropertyByLine( line, prop_value ) {
  
    $.ajax({
      type: 'post',
      dataType: 'json',
      asyc: false,
      url: '/cart/change.js',
      data: {
        line: line,
        properties: {
          'Weapon': prop_value
        }
      },
      success: function( cart ) {
        
        var total = cart.total_price / 100;
        
        $('form.custom span#total').text( '$' + total.toFixed(2) );
      }
    });
  }
  
 $(function() {
    var url = window.location.href;

    if (url.search('contact_posted') != -1) {
        $('html, body').animate({
            scrollTop: $('#contact_form').offset().top
        }, 1800);
    }
});   
  
  
  
});